/* unplugin-vue-components disabled */import { render } from "./FooterTabBar2.vue?vue&type=template&id=5b8a4a38&ts=true"
import script from "./FooterTabBar2.vue?vue&type=script&lang=ts"
export * from "./FooterTabBar2.vue?vue&type=script&lang=ts"

import "./FooterTabBar2.vue?vue&type=style&index=0&id=5b8a4a38&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__